const SITUATIONS = [
  {
    icon: 'ri-fire-line',
    title: 'Любите готовить на огне',
    desc: 'Шашлык, стейки, плов в казане — с&nbsp;оборудованной зоной готовка превращается в&nbsp;удовольствие. Всё&nbsp;под рукой, ничего не&nbsp;надо&nbsp;таскать.',
  },
  {
    icon: 'ri-group-line',
    title: 'Хотите обустроить зону отдыха',
    desc: 'Мангальная зона становится центром притяжения для семьи и&nbsp;гостей. Готовьте и&nbsp;общайтесь одновременно, не&nbsp;отвлекаясь&nbsp;на&nbsp;беготню.',
  },
  {
    icon: 'ri-gift-line',
    title: 'Нужен подарок для семьи и дома',
    desc: 'Мангальная зона — вложение в&nbsp;семейный уют на&nbsp;десятилетия. Праздники, выходные, вечерние посиделки станут&nbsp;особенными.',
  },
];

export default function UseCasesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6" style={{ maxWidth: '1400px' }}>
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Подойдёт, если вам нужно
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Три жизненные ситуации, в которых мангальная зона делает отдых на&nbsp;участке комфортнее и&nbsp;вкуснее
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5 max-w-4xl mx-auto">
          {SITUATIONS.map((item, idx) => (
            <div
              key={item.title}
              className="group bg-background-100 border border-background-200/70 rounded-lg p-5 md:p-6 transition-all duration-400 hover:border-primary-200/50 animate-fade-in-up"
              style={{ animationDelay: `${idx * 0.1}s` }}
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-400">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed" dangerouslySetInnerHTML={{ __html: item.desc }}></p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}